(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("eyeconicFileManager", [], factory);
	else if(typeof exports === 'object')
		exports["eyeconicFileManager"] = factory();
	else
		root["eyeconicFileManager"] = factory();
})(this, function() {
return 